export default class ResultsTableController {
    /*@ngInject*/
    constructor (ResultsService) {

    }
}

export default ResultsTableController;